module.exports = __webpack_public_path__ + "static/img/未佩戴安全帽识别.8dcc023a.png";